(() => {
  if (window.__ttQuoteBagLoaded) return;
  window.__ttQuoteBagLoaded = true;

  const STORAGE_KEY = 'tt_quote_bag_v2';
  const SIZE_RE = /\d{2,4}\s*[x×]\s*\d{1,3}(?:\.\d)?[A-Za-z]*\s*[x×]\s*\d{2,3}/i;
  const TREADS = [
    'C-Block',
    'Multi-Bar',
    'Zig-Zag',
    'Zig Zag',
    'Directional',
    'X-Terrain',
    'All-Terrain',
    'Tapered',
  ];

  function money(cents) {
    const value = Number.parseInt(cents, 10) || 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(value);
    }
    const template = window.priceFormatTemplate || '$0.00';
    const dollars = (value / 100).toFixed(2);
    if (template.indexOf('0.00') >= 0) return template.replace('0.00', dollars);
    if (template.indexOf('0') >= 0) return template.replace('0', dollars);
    return '$' + dollars;
  }

  function isTreadList(value) {
    const src = String(value || '');
    if (!src || src.indexOf(',') < 0) return false;
    const hits = TREADS.filter((name) => src.toLowerCase().indexOf(name.toLowerCase()) >= 0);
    return hits.length > 1;
  }

  function isDummyTitle(value) {
    return /^default title$/i.test(String(value || '').trim());
  }

  function oneTread(value) {
    const src = String(value || '').trim();
    if (!src || isDummyTitle(src) || isTreadList(src)) return '';
    const lower = src.toLowerCase();
    let found = '';
    TREADS.forEach((name) => {
      if (lower.indexOf(name.toLowerCase()) >= 0) {
        found = name === 'Zig Zag' ? 'Zig-Zag' : name;
      }
    });
    if (found) return found;
    if (/^[A-Za-z][A-Za-z0-9+/ \-]{1,40}$/.test(src) && !isDummyTitle(src)) return src;
    return '';
  }

  function extractSize(text) {
    const src = String(text || '');
    const match = src.match(SIZE_RE);
    return match ? match[0].replace(/\s+/g, '') : '';
  }

  function isTrackSize(value) {
    if (value == null) return false;
    if (typeof value === 'object') return false;
    const src = String(value).trim();
    if (!src || /^\d+$/.test(src)) return false;
    const extracted = extractSize(src);
    if (!extracted) return false;
    return src.replace(/\s+/g, '').toLowerCase() === extracted.toLowerCase();
  }

  function parseSizeTread(text) {
    const src = String(text || '')
      .replace(/\s*[—–]\s*Request Quote.*$/i, '')
      .trim();
    const size = extractSize(src);
    let rest = src;
    if (size) rest = src.replace(SIZE_RE, ' ').replace(/^[\s\-–—/,]+/, '').replace(/\s+[—–-]\s+\$[\d.,]+.*$/, '').trim();
    rest = rest.replace(/\s+[—–-]\s+\$[\d.,]+.*$/, '').trim();
    const tread = oneTread(rest) || oneTread(src);
    return { size, tread };
  }

  function sizeFrom() {
    for (let i = 0; i < arguments.length; i += 1) {
      const value = arguments[i];
      if (isTrackSize(value)) return String(value).replace(/\s+/g, '');
      const extracted = extractSize(value);
      if (extracted) return extracted;
    }
    return '';
  }

  function variantLabel(size, tread, fallback) {
    const s = sizeFrom(size, fallback);
    const t = oneTread(tread) || (isDummyTitle(fallback) ? '' : oneTread(fallback));
    if (s && t) return s + ' – ' + t;
    if (s) return s;
    if (t) return t;
    const parsed = parseSizeTread(fallback);
    if (parsed.size && parsed.tread) return parsed.size + ' – ' + parsed.tread;
    if (parsed.size) return parsed.size;
    return String(fallback || '')
      .replace(/\s*[—–]\s*Request Quote.*$/i, '')
      .replace(/\s+[—–-]\s+\$[\d.,]+.*$/, '')
      .replace(/^Default Title$/i, '')
      .trim();
  }

  function machineHandle(handle) {
    return String(handle || '')
      .replace(/-rubber-tracks.*$/i, '')
      .replace(/-tracks$/i, '');
  }

  function inferPartType(title, family) {
    const hay = ((family || '') + ' ' + (title || '')).toLowerCase();
    if (/sprocket/.test(hay)) return 'Drive Sprockets';
    if (/front.?idler|idlers/.test(hay) && /front/.test(hay)) return 'Front Idlers';
    if (/rear.?idler/.test(hay)) return 'Rear Idlers';
    if (/idler/.test(hay)) return 'Front Idlers';
    if (/top.?roller|upper.?roller/.test(hay)) return 'Top Rollers';
    if (/roller/.test(hay)) return 'Bottom Rollers';
    return 'Rubber Tracks';
  }

  function parseCatalog(el) {
    if (!el) return { variants: {} };
    try {
      return JSON.parse(el.textContent || '{}') || { variants: {} };
    } catch (e) {
      return { variants: {} };
    }
  }

  function catalogFrom(root) {
    if (!root) return { variants: {} };
    return parseCatalog(root.querySelector('[data-tt-quote-catalog]'));
  }

  function catalogForVariant(variantId, root) {
    const fromRoot = catalogFrom(root);
    if (variantId && fromRoot.variants && fromRoot.variants[variantId]) return fromRoot;
    if (!variantId) return fromRoot;
    const scripts = document.querySelectorAll('[data-tt-quote-catalog]');
    for (let i = 0; i < scripts.length; i += 1) {
      const data = parseCatalog(scripts[i]);
      if (data.variants && data.variants[variantId]) return data;
    }
    return fromRoot;
  }

  function rowForVariant(variantId) {
    if (!variantId) return null;
    const inputs = document.querySelectorAll('[data-tt-quote-root] input[name="id"]');
    for (let i = 0; i < inputs.length; i += 1) {
      if (String(inputs[i].value) === String(variantId)) {
        return inputs[i].closest('[data-tt-quote-root]');
      }
    }
    return null;
  }

  function priceFromCard(root) {
    if (!root) return 0;
    const el = root.querySelector('.tt-machine-part-row__price strong, [data-tread-price]');
    if (!el) return 0;
    const text = String(el.textContent || '').replace(/,/g, '');
    const match = text.match(/(\d+)\.(\d{2})/);
    if (!match) return 0;
    return Number.parseInt(match[1], 10) * 100 + Number.parseInt(match[2], 10);
  }

  function centsFrom(value) {
    const n = Number.parseInt(value, 10);
    return n > 0 ? n : 0;
  }

  function qtyFrom(root) {
    if (!root) return 1;
    const input =
      root.querySelector('input[name="quantity"]') ||
      root.querySelector('.qty-field') ||
      root.querySelector('.quantity-input');
    const qty = Number.parseInt(input && input.value, 10);
    return qty > 0 ? qty : 1;
  }

  function currentVariantId(root, trigger) {
    if (trigger && trigger.getAttribute('data-variant-id')) return String(trigger.getAttribute('data-variant-id'));
    const input = root && root.querySelector('input[name="id"]');
    if (input && input.value) return String(input.value);
    const select = root && root.querySelector('.tread-select');
    if (select && select.value) return String(select.value);
    return '';
  }

  function lineKey(line) {
    return String((line && (line.variantId || line.sku || line.handle)) || '');
  }

  function normalizeLine(item) {
    if (!item || typeof item !== 'object') return null;
    const title = String(item.title || '');
    const parsedTitle = parseSizeTread(title);
    const size = sizeFrom(item.trackSize, item.variantLabel, item.variantTitle, title);
    let tread = oneTread(item.treadPattern);
    if (!tread) tread = oneTread(item.variantLabel) || oneTread(item.variantTitle) || parsedTitle.tread;
    const label = variantLabel(size, tread, item.variantLabel || item.variantTitle || title);
    const price = centsFrom(item.price);
    return Object.assign({}, item, {
      trackSize: size,
      treadPattern: tread,
      variantLabel: label,
      variantTitle: isDummyTitle(item.variantTitle) ? label : (item.variantTitle || label),
      price,
      qty: Math.max(1, Number.parseInt(item.qty, 10) || 1),
    });
  }

  function loadBag() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      if (parsed && Array.isArray(parsed.lines)) {
        return { lines: parsed.lines.map(normalizeLine).filter((line) => line && lineKey(line)) };
      }
    } catch (e) { /* ignore */ }
    return { lines: [] };
  }

  function saveBag(bag) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ lines: bag.lines || [] }));
  }

  function collectLine(trigger) {
    const block = trigger.closest('[data-tt-tread-buy-block]');
    const formRoot = trigger.closest('[data-tt-quote-root]') || trigger.closest('product-form') || trigger.closest('form');
    const variantId = currentVariantId(block || formRoot, trigger);
    const row = formRoot || block || rowForVariant(variantId);
    const catalog = catalogForVariant(variantId, row);
    const data = (catalog.variants && catalog.variants[variantId]) || {};
    const option = block && block.querySelector('.tread-select') && block.querySelector('.tread-select').selectedOptions[0];
    const selectedText =
      (option && option.getAttribute('data-tread')) ||
      (data.title && !isDummyTitle(data.title) ? data.title : '') ||
      (data.options && !isDummyTitle(data.options) ? data.options : '') ||
      (option && !isDummyTitle(option.textContent) ? option.textContent : '');
    const handle = (row && row.dataset.productHandle) || catalog.handle || '';
    const title = (row && row.dataset.productTitle) || catalog.title || document.title;
    const parsed = parseSizeTread(selectedText || title);
    const productUrl = (row && row.dataset.productUrl) || catalog.url || (window.location && window.location.href) || '';
    const sku = (option && option.dataset.variantSku) || data.sku || '';
    let price =
      centsFrom(trigger && trigger.getAttribute('data-variant-price')) ||
      centsFrom(option && option.dataset.variantPrice) ||
      centsFrom(data.price);
    if (!price) price = priceFromCard(row);
    const image =
      (option && option.dataset.variantImage) ||
      data.image ||
      catalog.image ||
      '';
    const size = sizeFrom(
      trigger && trigger.getAttribute('data-track-size'),
      option && option.dataset.size,
      data.trackSize,
      parsed.size,
      title,
      selectedText
    );
    const tread =
      oneTread((trigger && trigger.getAttribute('data-tread')) || (option && option.dataset.tread) || data.treadPattern) ||
      parsed.tread ||
      '';
    const label = variantLabel(size, tread, selectedText);
    const fallbackAttr = trigger.getAttribute('data-tt-quote-line');
    if (fallbackAttr && !variantId) {
      try {
        return normalizeLine(JSON.parse(fallbackAttr));
      } catch (e) { /* fall through */ }
    }
    return normalizeLine({
      variantId: String(variantId || ''),
      handle,
      machineHandle: machineHandle(handle),
      sku,
      title,
      variantLabel: label,
      variantTitle: label,
      qty: qtyFrom(block || formRoot),
      image,
      price,
      productUrl,
      trackSize: size,
      treadPattern: tread,
      partType: inferPartType(title, catalog.productFamily),
      canonicalHandle: (option && option.dataset.canonicalHandle) || catalog.handle || handle,
    });
  }

  function addLine(line) {
    const normalized = normalizeLine(line);
    if (!normalized || !lineKey(normalized)) return loadBag();
    const bag = loadBag();
    const key = lineKey(normalized);
    const existing = bag.lines.find((item) => lineKey(item) === key);
    const addQty = Math.max(1, Number.parseInt(normalized.qty, 10) || 1);
    if (existing) {
      existing.qty = Math.max(1, Number.parseInt(existing.qty, 10) || 1) + addQty;
    } else {
      bag.lines.push(Object.assign({}, normalized, { qty: addQty }));
    }
    saveBag(bag);
    return bag;
  }

  function setQty(variantId, qty) {
    const bag = loadBag();
    const next = Math.max(0, Number.parseInt(qty, 10) || 0);
    bag.lines = bag.lines
      .map((item) => {
        if (lineKey(item) !== String(variantId)) return item;
        return Object.assign({}, item, { qty: next });
      })
      .filter((item) => item.qty > 0);
    saveBag(bag);
    return bag;
  }

  function removeLine(variantId) {
    const bag = loadBag();
    bag.lines = bag.lines.filter((item) => lineKey(item) !== String(variantId));
    saveBag(bag);
    return bag;
  }

  function clearBag() {
    saveBag({ lines: [] });
    return loadBag();
  }

  function lineCount(bag) {
    return (bag.lines || []).reduce((sum, item) => sum + (Number.parseInt(item.qty, 10) || 0), 0);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formUrl() {
    const drawer = document.getElementById('Quote-Drawer');
    const base = (drawer && drawer.getAttribute('data-quote-form-url')) || '/pages/request-a-quote';
    const bag = loadBag();
    const first = bag.lines[0] || {};
    const params = new URLSearchParams();
    params.set('source', 'quote_drawer');
    if (first.handle) params.set('product', first.handle);
    if (first.variantId) params.set('variant', first.variantId);
    if (first.sku) params.set('sku', first.sku);
    if (first.title) params.set('title', first.title);
    if (first.productUrl) params.set('product_url', first.productUrl);
    return base + '?' + params.toString();
  }

  function displayPrice(item) {
    const unit = centsFrom(item && item.price);
    const qty = Math.max(1, Number.parseInt(item && item.qty, 10) || 1);
    if (unit > 0) return money(unit * qty);
    return 'Quote';
  }

  function mountHeaderTrigger() {
    if (document.querySelector('[data-quote-drawer-open]')) return;
    const cart =
      document.querySelector('.header-right .cart-drawer-opener') ||
      document.getElementById('Cart-Icon-Bubble');
    if (!cart || !cart.parentNode) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'header-icon quote-header-opener';
    btn.setAttribute('data-quote-drawer-open', '');
    btn.setAttribute('aria-controls', 'Quote-Drawer');
    btn.setAttribute('aria-label', 'Open quote');
    btn.innerHTML = 'Quote (<span data-quote-count>0</span>)';
    btn.hidden = true;
    cart.parentNode.insertBefore(btn, cart);
  }

  function updateCounts(count) {
    mountHeaderTrigger();
    document.querySelectorAll('[data-quote-count]').forEach((el) => {
      el.textContent = String(count);
    });
    document.querySelectorAll('[data-quote-drawer-open]').forEach((el) => {
      el.hidden = count < 1;
    });
  }

  function renderDrawer() {
    const drawer = document.getElementById('Quote-Drawer');
    const bag = loadBag();
    saveBag(bag);
    const count = lineCount(bag);
    updateCounts(count);
    if (!drawer) return;
    const body = drawer.querySelector('[data-quote-drawer-body]');
    const footer = drawer.querySelector('[data-quote-drawer-footer]');
    const request = drawer.querySelector('[data-quote-request]');
    if (request) request.setAttribute('href', formUrl());
    if (footer) footer.hidden = !bag.lines.length;
    if (!body) return;
    if (!bag.lines.length) {
      body.innerHTML =
        '<div class="quote-drawer-empty cart-details-inner--empty">' +
        '<h2 class="uppercase h4 mb-4">Your quote is empty</h2>' +
        '<button type="button" class="button" data-quote-continue>Continue shopping</button>' +
        '</div>';
      return;
    }
    const items = bag.lines
      .map((item) => {
        const meta = item.variantLabel || variantLabel(item.trackSize, item.treadPattern, item.variantTitle);
        const img = item.image
          ? '<img src="' + escapeHtml(item.image) + '" alt="" width="90" height="90">'
          : '';
        const href = item.productUrl ? escapeHtml(item.productUrl) : '#';
        return (
          '<li class="quote-line" data-quote-variant="' +
          escapeHtml(lineKey(item)) +
          '">' +
          '<a class="quote-line__media" href="' +
          href +
          '">' +
          img +
          '</a>' +
          '<div class="quote-line__info">' +
          '<a class="quote-line__name" href="' +
          href +
          '">' +
          escapeHtml(item.title) +
          '</a>' +
          (meta ? '<p class="quote-line__meta">' + escapeHtml(meta) + '</p>' : '') +
          '<div class="quote-line__qty">' +
          '<button type="button" data-quote-qty-minus aria-label="Decrease quantity">−</button>' +
          '<input type="number" min="1" max="99" value="' +
          escapeHtml(item.qty) +
          '" data-quote-qty-input aria-label="Quantity">' +
          '<button type="button" data-quote-qty-plus aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button type="button" class="quote-line__remove" data-quote-remove>Remove</button>' +
          '</div>' +
          '<div class="quote-line__price">' +
          escapeHtml(displayPrice(item)) +
          '</div>' +
          '</li>'
        );
      })
      .join('');
    body.innerHTML = '<ul class="quote-drawer-list">' + items + '</ul>';
  }

  function drawerBase() {
    if (typeof Drawer === 'function') return Drawer;
    return customElements.get('drawer-component') || null;
  }

  function openDrawer() {
    renderDrawer();
    const drawer = document.getElementById('Quote-Drawer');
    if (!drawer) return;
    if (typeof drawer.show === 'function') drawer.show();
    else drawer.setAttribute('open', '');
  }

  function closeDrawer() {
    const drawer = document.getElementById('Quote-Drawer');
    if (!drawer) return;
    if (typeof drawer.hide === 'function') drawer.hide();
    else drawer.removeAttribute('open');
  }

  function isSerialFitmentTrigger(el) {
    if (!el) return false;
    const href = String(el.getAttribute('href') || '');
    return el.getAttribute('data-tt-fitment-gate') === 'resolver_gated' || href.indexOf('source=serial_fitment') >= 0;
  }

  function isQuoteTrigger(el) {
    if (!el) return false;
    if (el.closest && el.closest('#Quote-Drawer')) return false;
    if (isSerialFitmentTrigger(el)) return false;
    return el.matches(
      '[data-tt-add-to-quote], [data-tt-quote-button], [data-tread-add-to-quote], [data-tread-quote-button]'
    );
  }

  document.addEventListener(
    'click',
    (event) => {
      const opener = event.target.closest && event.target.closest('[data-quote-drawer-open]');
      if (opener) {
        event.preventDefault();
        event.stopPropagation();
        openDrawer();
        return;
      }

      /* Motto ModalDialog.handleOverlayClick stopPropagates every drawer click
         on bubble. Qty / remove / close must run in capture or they never fire. */
      const drawer = event.target.closest && event.target.closest('#Quote-Drawer');
      if (drawer) {
        if (event.target.closest('[data-quote-continue]')) {
          event.preventDefault();
          event.stopPropagation();
          closeDrawer();
          return;
        }
        if (event.target.closest('.drawer-close-button, [data-quote-close], .modal-overlay')) {
          event.preventDefault();
          event.stopPropagation();
          closeDrawer();
          return;
        }
        const request = event.target.closest('[data-quote-request]');
        if (request) {
          request.setAttribute('href', formUrl());
          return;
        }
        const line = event.target.closest('.quote-line');
        const variantId = line && line.getAttribute('data-quote-variant');
        if (!variantId) return;
        if (event.target.closest('[data-quote-remove]')) {
          event.preventDefault();
          event.stopPropagation();
          removeLine(variantId);
          renderDrawer();
          return;
        }
        if (event.target.closest('[data-quote-qty-minus]')) {
          event.preventDefault();
          event.stopPropagation();
          const input = line.querySelector('[data-quote-qty-input]');
          setQty(variantId, (Number.parseInt(input && input.value, 10) || 1) - 1);
          renderDrawer();
          return;
        }
        if (event.target.closest('[data-quote-qty-plus]')) {
          event.preventDefault();
          event.stopPropagation();
          const input = line.querySelector('[data-quote-qty-input]');
          setQty(variantId, (Number.parseInt(input && input.value, 10) || 1) + 1);
          renderDrawer();
        }
        return;
      }

      const trigger = event.target.closest && event.target.closest('a, button');
      if (!isQuoteTrigger(trigger)) return;
      const line = collectLine(trigger);
      if (!line || !lineKey(line)) return;
      event.preventDefault();
      event.stopPropagation();
      const bag = addLine(line);
      if (bag.lines.length) openDrawer();
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target.closest && event.target.closest('[data-quote-qty-input]');
      if (!input) return;
      const line = input.closest('.quote-line');
      const variantId = line && line.getAttribute('data-quote-variant');
      if (!variantId) return;
      setQty(variantId, input.value);
      renderDrawer();
    },
    true
  );

  function defineDrawer() {
    if (customElements.get('quote-drawer')) return true;
    const Base = drawerBase();
    if (!Base) return false;
    customElements.define(
      'quote-drawer',
      class QuoteDrawer extends Base {
        connectedCallback() {
          if (typeof super.connectedCallback === 'function') super.connectedCallback();
          renderDrawer();
        }
        show(opener) {
          if (typeof super.show === 'function') super.show(opener);
          else this.setAttribute('open', '');
        }
        hide() {
          if (typeof super.hide === 'function') super.hide();
          else this.removeAttribute('open');
        }
      }
    );
    return true;
  }

  function ensureDrawer() {
    if (defineDrawer()) {
      renderDrawer();
      return;
    }
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('drawer-component').then(() => {
        defineDrawer();
        renderDrawer();
      });
    }
    window.addEventListener('DOMContentLoaded', () => {
      if (!defineDrawer()) {
        const Fallback = HTMLElement;
        if (!customElements.get('quote-drawer')) {
          customElements.define(
            'quote-drawer',
            class QuoteDrawer extends Fallback {
              show() {
                this.setAttribute('open', '');
              }
              hide() {
                this.removeAttribute('open');
              }
            }
          );
        }
      }
      renderDrawer();
    });
  }

  window.TTQuoteBag = {
    key: STORAGE_KEY,
    load: loadBag,
    save: saveBag,
    add: addLine,
    setQty,
    remove: removeLine,
    clear: clearBag,
    open: openDrawer,
    close: closeDrawer,
    render: renderDrawer,
    formUrl,
    count: () => lineCount(loadBag()),
  };

  ensureDrawer();
  renderDrawer();
})();
